"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Ideation = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _header = _interopRequireDefault(require("../header"));

var _buttonControl = _interopRequireDefault(require("../../preact-components/button-control"));

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

var _AccordionPanel = _interopRequireDefault(require("../panel/AccordionPanel"));

var _PanelHeaderWithIcon = require("../ui-components/PanelHeaderWithIcon");

var _SimplePanel = _interopRequireDefault(require("../ui-components/SimplePanel"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var trackExport = function trackExport() {
  _publish.default.trackEvent('userevent', {
    type: 'Ideation Data Exported'
  });
};

var dataExportPanel = {
  heading: 'Analytics',
  title: (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
    title: "Data export",
    icon: "downloadCloud",
    customClass: "panel-header-container"
  }),
  body: (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)("/ideas/export"),
    target: "_blank",
    className: "ideation-ideas-export",
    onClick: trackExport
  }, (0, _preact.h)(_buttonControl.default, {
    newStyle: true,
    size: "medium",
    title: "Export all ideas in CSV",
    variant: "brand"
  }))
};

var Ideation = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Ideation, _Component);

  var _super = _createSuper(Ideation);

  function Ideation() {
    (0, _classCallCheck2.default)(this, Ideation);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Ideation, [{
    key: "render",
    value: function render() {
      return (0, _preact.h)("div", {
        className: "ideation-platform-page"
      }, (0, _preact.h)(_header.default, {
        title: "Ideation",
        disableSaveButton: true,
        disableCancelButton: true,
        customButtons: [(0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("/idea/overview"),
          target: "_blank",
          key: "ideas-overview"
        }, (0, _preact.h)(_buttonControl.default, {
          title: (0, _preact.h)("div", {
            className: "ideation-overview-link"
          }, "Go to ideation overview page", (0, _preact.h)(_assets.default, {
            icon: "openInNew",
            width: 16,
            height: 16
          })),
          variant: "secondary",
          newStyle: true,
          size: "medium"
        }))]
      }), (0, _preact.h)(_AccordionPanel.default, {
        panels: [dataExportPanel]
      }), (0, _preact.h)("h2", {
        className: "panel-new__heading ideation-platform-settings"
      }, "Setting"), (0, _preact.h)(_SimplePanel.default, {
        className: "ideation-platform-permissions-panel",
        image: (0, _preact.h)(_assets.default, {
          icon: "key",
          width: 30,
          height: 30,
          color: "#0069FF"
        })
      }, (0, _preact.h)("a", {
        className: "ideation-platform-permissions-link",
        href: (0, _absoluteUrlRuntime.resolveUrl)("/platform/ideation/permissions")
      }), (0, _preact.h)("div", {
        className: "ideation-permissions__title"
      }, (0, _preact.h)("h5", null, "Permissions")), (0, _preact.h)("div", {
        className: "ideation-permissions__description"
      }, "Manage visibility, creation, reply and upvote permissions")));
    }
  }]);
  return Ideation;
}(_preact.Component);

exports.Ideation = Ideation;
var _default = Ideation;
exports.default = _default;